import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../store/slices/languageSlice";
import { updatePreferredLanguage } from "../services/authService";
import { getStoredLanguage, normalizeLanguageCode } from "../utils/language";

const LanguageDropdown = () => {
    const { t, i18n } = useTranslation();
    const [language, setLocalLanguage] = useState(
        getStoredLanguage()
    );

    const dispatch = useDispatch();
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

    const handleChange = async (e) => {
        const selectedLang = normalizeLanguageCode(e.target.value);

        setLocalLanguage(selectedLang);
        localStorage.setItem("language", selectedLang);
        i18n.changeLanguage(selectedLang);
        dispatch(setLanguage(selectedLang));

        if (!isLoggedIn) return;

        try {
            await updatePreferredLanguage(selectedLang);
        } catch (error) {
            // можно оставить пустым, если не хочешь показывать ошибку
        }
    };

    return (
        <select
            id="language-select"
            name="language"
            value={language}
            onChange={handleChange}
            aria-label={t("language")}
            className="text-sm bg-[#1C1C1C] text-[#AAA] px-2 rounded-lg border border-gray-700 py-1"
        >
            <option value="ru">{t("language.ru")}</option>
            <option value="uk">{t("language.ua")}</option>
        </select>
    );
};

export default LanguageDropdown;
